export default __webpack_public_path__ + "static/media/magon-1-lounge-20220325-min.55b39bb9.jpg";